import { t } from "../../../services/utils";
import BaseStoryViewModel from "./BaseStoryViewModel";
import LinkView from "../components/LinkView";
import TextView from "../components/TextView";
class LinkStoryViewModel extends BaseStoryViewModel {
  constructor(story, me, viewType) {
    super(story, me, viewType);
  }
  getStoryDate = () => {
    return this.story.story.da;
  };
  addContentViewModel = (parts, handler) => {
    if (this.story.story.no) {
      parts.push({
        type: TextView,
        props: {
          text: this.story.story.no.trim(),
          paddingBottom: 1,
        },
        key: `note-${this.story.story_id}`,
      });
    }
    parts.push({
      type: LinkView,
      props: {
        link: this.story.story,
      },
      key: `lv-${this.story.story_id}`,
    });
  };
}
export default LinkStoryViewModel;
